import { tv } from 'tailwind-variants';

import { TextFieldType } from './TextField.consts';

export const textField = tv({
  slots: {
    container: 'flex flex-col gap-1',
    field:
      'border-1 focus-within:border-primary-highlight focus-within:hover:border-primary-highlight flex w-full items-center rounded bg-black py-1 pl-2 pr-4 text-white outline-none transition-colors duration-100',
    input:
      'w-full bg-transparent py-[1px] outline-none placeholder:text-white/40',
    textArea:
      'w-full resize-none bg-transparent outline-none placeholder:text-white/40'
  },
  variants: {
    fieldType: {
      [TextFieldType.DEFAULT]: {
        field: 'border-white/30 hover:border-white/70'
      },
      [TextFieldType.HIGHLIGHT]: {
        field: 'border-primary-bright hover:border-primary-bright-hover'
      },
      [TextFieldType.SIMPLE]: {
        field: 'rounded-none border-none bg-transparent'
      },
      [TextFieldType.INPUT_BUTTON]: {
        field:
          'focus-within:border-primary-border-alt focus-within:hover:border-primary-border-alt border-1 border-primary-border-alt rounded-r-none border-r-0 bg-transparent'
      }
    },
    error: {
      true: {
        field: 'border-red-500 hover:border-red-500 focus:border-red-500'
      }
    },
    disabled: {
      true: {
        field: 'cursor-not-allowed border-none bg-white/10 opacity-70',
        input: 'cursor-not-allowed',
        textArea: 'cursor-not-allowed'
      }
    },
    disabledInputButton: {
      true: {
        field: 'cursor-not-allowed'
      }
    },
    fullWidth: {
      true: {
        container: 'w-full'
      }
    },
    animateStartIcon: {
      true: {
        container: [
          '[&_.MuiInputAdornment-root]:opacity-60',
          '[&:hover_.MuiInputAdornment-root]:opacity-100',
          '[&:focus-within_.MuiInputAdornment-root]:opacity-100'
        ]
      }
    },
    showFocusBottomBorder: {
      true: {
        input:
          'border-b border-transparent focus:border-b focus:border-[#8d76ff]'
      }
    }
  },
  compoundVariants: [
    {
      fieldType: TextFieldType.INPUT_BUTTON,
      disabled: true,
      class: {
        field: 'cursor-not-allowed'
      }
    }
  ]
});
